var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.59766V5.59766C17 4.49309 16.1046 3.59766 15 3.59766H3C1.89543 3.59766 1 4.49309 1 5.59766V8.59766M17 8.59766V17.5977C17 18.7023 16.1046 19.5977 15 19.5977H3C1.89543 19.5977 1 18.7023 1 17.5977V8.59766M17 8.59766H1M5 1.59766V5.59766M13 1.59766V5.59766",
    stroke: "#3A6D33",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.5977H3.5C3.22386 10.5977 3 10.8215 3 11.0977V13.0977C3 13.3738 3.22386 13.5977 3.5 13.5977H5.5C5.77614 13.5977 6 13.3738 6 13.0977V11.0977C6 10.8215 5.77614 10.5977 5.5 10.5977Z",
    fill: "#3A6D33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5977H8C7.72386 10.5977 7.5 10.8215 7.5 11.0977V13.0977C7.5 13.3738 7.72386 13.5977 8 13.5977H10C10.2761 13.5977 10.5 13.3738 10.5 13.0977V11.0977C10.5 10.8215 10.2761 10.5977 10 10.5977Z",
    fill: "#3A6D33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.5977H12.5C12.2239 10.5977 12 10.8215 12 11.0977V13.0977C12 13.3738 12.2239 13.5977 12.5 13.5977H14.5C14.7761 13.5977 15 13.3738 15 13.0977V11.0977C15 10.8215 14.7761 10.5977 14.5 10.5977Z",
    fill: "#3A6D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e4038eb7cf99f8268f945179ef82bff6.svg";
export { ForwardRef as ReactComponent };